import { render } from "./MenuSub.vue?vue&type=template&id=8c461e42"
import script from "./MenuSub.vue?vue&type=script&lang=js"
export * from "./MenuSub.vue?vue&type=script&lang=js"

import "./MenuSub.vue?vue&type=style&index=0&id=8c461e42&lang=scss"
script.render = render

export default script